// import React, { createContext, useState, useContext, useEffect } from "react";

// // Create Context
// const YearContext = createContext();

// // Provider Component
// export const YearProvider = ({ children }) => {
//   const today = new Date();
//   const currentYear = today.getFullYear();
//   const currentMonth = today.getMonth();

//   const cutoff = new Date(currentYear, 10, 29);
//   let taxYear;
//   // if (currentMonth > 9) {
//   //   taxYear = currentYear;
//   // }
//   if (today >= cutoff) {
//     taxYear = currentYear;
//   } else {
//     taxYear = currentYear - 1;
//   }
//   const [yearSelected, setYearSelected] = useState(taxYear.toString());

//   // useEffect(() => {
//   //   const storedYear = localStorage.getItem("yearSelected");
//   //   if (!storedYear) {
//   //     localStorage.setItem("yearSelected", taxYear.toString());
//   //     setYearSelected(taxYear.toString());
//   //   } else {
//   //     setYearSelected(storedYear);
//   //   }
//   // }, []);

//   useEffect(() => {
//   const storedYear = localStorage.getItem("yearSelected");
  
//   // If stored year is older than current tax year -> update automatically
//   if (!storedYear || parseInt(storedYear) < taxYear) {
//     localStorage.setItem("yearSelected", taxYear.toString());
//     setYearSelected(taxYear.toString());
//   } else {
//     setYearSelected(storedYear);
//   }
// }, []);

//   const onYearChange = (newYear) => {
//     setYearSelected(newYear);
//     localStorage.setItem("yearSelected", newYear);
//   };

//   const clearYearFromLocalStorage = () => {
//     localStorage.removeItem("yearSelected");
//     setYearSelected(taxYear.toString());
//   };

//   return (
//     <YearContext.Provider
//       value={{ yearSelected, onYearChange, clearYearFromLocalStorage }}
//     >
//       {children}
//     </YearContext.Provider>
//   );
// };

// // Custom Hook to use Year Context
// export const useYearContext = () => {
//   return useContext(YearContext);
// };

import React, { createContext, useState, useContext, useEffect } from "react";

const YearContext = createContext();

export const YearProvider = ({ children }) => {
  const today = new Date();
  const currentYear = today.getFullYear();

  const cutoff = new Date(currentYear, 10, 29); // Nov 29
  const taxYear = today >= cutoff ? currentYear : currentYear - 1;

  const [yearSelected, setYearSelected] = useState(taxYear.toString());

  useEffect(() => {
    const storedYear = localStorage.getItem("yearSelected");

    // --- AUTO UPDATE YEAR IF NEW FINANCIAL YEAR STARTED ---
    if (!storedYear) {
      // First time login
      localStorage.setItem("yearSelected", taxYear.toString());
      setYearSelected(taxYear.toString());
    } else {
      // Compare stored year with the new calculated year
      if (storedYear !== taxYear.toString()) {
        // Financial year rolled over → auto update
        localStorage.setItem("yearSelected", taxYear.toString());
        setYearSelected(taxYear.toString());
      } else {
        // Otherwise keep stored value
        setYearSelected(storedYear);
      }
    }
  }, [taxYear]);

  const onYearChange = (newYear) => {
    setYearSelected(newYear);
    localStorage.setItem("yearSelected", newYear);
  };
  const clearYearFromLocalStorage = () => {
    localStorage.removeItem("yearSelected");
    setYearSelected(taxYear.toString());
  };
  return (
    <YearContext.Provider value={{ yearSelected, onYearChange ,clearYearFromLocalStorage  }}>
      {children}
    </YearContext.Provider>
  );
};

export const useYearContext = () => useContext(YearContext);
